import { render, staticRenderFns } from "./PointRewardPunishmentsLists.vue?vue&type=template&id=60a1855a&"
import script from "./PointRewardPunishmentsLists.vue?vue&type=script&lang=js&"
export * from "./PointRewardPunishmentsLists.vue?vue&type=script&lang=js&"
import style0 from "./PointRewardPunishmentsLists.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports